import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
function DefaultImageComponent({
  src,
  alt,
  width,
  height,
  className,
  loading = 'lazy'
}) {
  const isStaticallyImported = typeof src === 'object';
  const imgWidth = width || (isStaticallyImported ? src.width : undefined);
  const imgHeight = height || (isStaticallyImported ? src.height : undefined);
  return /*#__PURE__*/jsx("img", {
    src: typeof src === 'object' ? src.src : src,
    alt: alt || '',
    width: imgWidth,
    height: imgHeight,
    loading: loading,
    className: className
  });
}
const ImageComponentContext = /*#__PURE__*/createContext(DefaultImageComponent);
function ImageComponentProvider({
  children,
  imageComponent = DefaultImageComponent
}) {
  return /*#__PURE__*/jsx(ImageComponentContext.Provider, {
    value: imageComponent,
    children: children
  });
}
const useImageComponent = () => useContext(ImageComponentContext);
export { ImageComponentProvider, useImageComponent };
//# sourceMappingURL=ImageComponentProvider.js.map
